import { useNavigate, useLocation } from "react-router-dom";

export function useScrollToTop() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (targetPath: string) => {
    if (location.pathname === targetPath) {
      // Already on target page, scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Navigate to target page
      navigate(targetPath);
    }
  };

  return handleNavigation;
}